var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: { titulo: _vm.titulo, width: 500, hasFooter: false },
      on: { closeModal: _vm.closeModal }
    },
    [
      _c(
        "template",
        { staticClass: "conteudoModal", slot: "body" },
        [
          _c(
            "el-row",
            { attrs: { type: "flex" } },
            [
              _c("el-switch", {
                attrs: { "active-color": "#13ce66" },
                model: {
                  value: _vm.receberNotificacao,
                  callback: function($$v) {
                    _vm.receberNotificacao = $$v
                  },
                  expression: "receberNotificacao"
                }
              }),
              _c(
                "i",
                {
                  style: {
                    "margin-left": "5px",
                    color: _vm.receberNotificacao ? "#009f61" : "#606266"
                  }
                },
                [_vm._v("Habilitar notificação")]
              )
            ],
            1
          ),
          _c("div", { staticClass: "containerInputs" }, [
            _c(
              "label",
              [
                _c("strong", [_vm._v("Nome:")]),
                _c("el-input", {
                  staticClass: "input",
                  attrs: { maxlength: "100", placeholder: "Nome" },
                  model: {
                    value: _vm.nome,
                    callback: function($$v) {
                      _vm.nome = $$v
                    },
                    expression: "nome"
                  }
                })
              ],
              1
            ),
            _c(
              "label",
              [
                _c("strong", [_vm._v("Nome do serviço:")]),
                _c("el-input", {
                  staticClass: "input",
                  attrs: { maxlength: "100", placeholder: "Nome do serviço" },
                  model: {
                    value: _vm.nomeDoServico,
                    callback: function($$v) {
                      _vm.nomeDoServico = $$v
                    },
                    expression: "nomeDoServico"
                  }
                })
              ],
              1
            ),
            _c(
              "label",
              [
                _c("strong", [_vm._v("Ip:")]),
                _c("el-input", {
                  staticClass: "input",
                  attrs: {
                    placeholder: "Ip",
                    maxlength: "15",
                    "show-word-limit": "show-word-limit"
                  },
                  model: {
                    value: _vm.ip,
                    callback: function($$v) {
                      _vm.ip = $$v
                    },
                    expression: "ip"
                  }
                })
              ],
              1
            ),
            _c(
              "label",
              [
                _c("strong", [_vm._v("Porta:")]),
                _c("el-input", {
                  staticClass: "input",
                  attrs: {
                    maxlength: "100",
                    placeholder: "Porta",
                    type: "number"
                  },
                  model: {
                    value: _vm.porta,
                    callback: function($$v) {
                      _vm.porta = $$v
                    },
                    expression: "porta"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "containerBotao" },
            [
              _c(
                "el-button",
                { staticClass: "botaoModal", on: { click: _vm.closeModal } },
                [_vm._v("cancelar")]
              ),
              !_vm.moduloParaEditar
                ? _c(
                    "el-button",
                    {
                      staticClass: "botaoModal",
                      attrs: { type: "primary" },
                      on: { click: _vm.adicionar }
                    },
                    [_vm._v("Cadastrar")]
                  )
                : _c(
                    "el-button",
                    {
                      staticClass: "botaoModal",
                      attrs: { type: "primary" },
                      on: { click: _vm.atualizarModulo }
                    },
                    [_vm._v("atualizar")]
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80e5d65c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80e5d65c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/components/modal/AppModalGerenciamentoModulos.vue
// module id = null
// module chunks = 